export default "__VITE_ASSET__DXM8XhLf__"